import React, { useState } from "react";
import "../../styles/contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [statusMessage, setStatusMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simulate form submission
    setStatusMessage("Message sent successfully!");
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <div className="cyberpunk-contact-container">
      <h1 className="cyberpunk-title">Get in Touch</h1>
      <p className="cyberpunk-description">
        We'd love to hear from you. Send us a message and we'll respond as soon as possible.
      </p>
      <form className="cyberpunk-form" onSubmit={handleSubmit}>
        <div className="cyberpunk-form-group">
          <label htmlFor="name">Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter your name"
            required
          />
        </div>
        <div className="cyberpunk-form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter your email"
            required
          />
        </div>
        <div className="cyberpunk-form-group">
          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Write your message"
            required
          ></textarea>
        </div>
        <button type="submit" className="cyberpunk-button">
          Send Message
        </button>
      </form>
      {statusMessage && <p className="cyberpunk-status">{statusMessage}</p>}

      {/* Call Corwin Hiatt Section */}
      <p className="cyberpunk-call">
        Or call <span>Corwin Hiatt</span> at <a href="tel:971-267-9344">971-267-9344</a>
      </p>
    </div>
  );
};

export default Contact;